import { useCallback, useState } from 'react';

/**
 * Marca en rojo los campos requeridos que faltan, solo después de intentar guardar.
 *
 *   const required = useRequiredFields();
 *   // al guardar
 *   if (!name) { required.fail(); setErrorMessage('Debe completar los campos requeridos.'); return; }
 *   // en el campo (el rojo se quita apenas se llena)
 *   <input className={`form-control${required.mark(!name)}`} ... />
 *   <div className="invalid-feedback">Campo requerido</div>
 */
export const useRequiredFields = () => {
    const [attempted, setAttempted] = useState(false);

    // ' is-invalid' si ya se intentó guardar y el campo falta
    const mark = useCallback((missing: boolean) => (attempted && missing ? ' is-invalid' : ''), [attempted]);

    // Activa las marcas y lleva al primer campo que falta
    const fail = useCallback(() => {
        setAttempted(true);
        setTimeout(() => {
            const first = document.querySelector<HTMLElement>('.is-invalid');
            if (first) {
                first.scrollIntoView({ block: 'center', behavior: 'smooth' });
                first.focus({ preventScroll: true });
            }
        }, 50);
    }, []);

    const reset = useCallback(() => setAttempted(false), []);

    return { attempted, mark, fail, reset };
};
